import { Component, OnInit, Output, ViewChild, ViewEncapsulation, AfterViewInit, Input } from '@angular/core';
import { BehaviorSubject } from '../../../../../../node_modules/rxjs';
import { MatMenuTrigger } from '@angular/material/menu';
import DOMPurify from 'dompurify';

@Component({
  selector: 'note-editor',
  templateUrl: './note-editor.component.html',
  styleUrls: ['./note-editor.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class NoteEditorComponent implements OnInit, AfterViewInit{
  
  _value = '';
  
  // we create an object that contains coordinates 
  menuTopLeftPosition =  {x: '0', y: '0'} 
 
  // reference to the MatMenuTrigger in the DOM 
  @ViewChild(MatMenuTrigger) matMenuTrigger: MatMenuTrigger; 
  
  @Input() set value(val: string){
    this._value = DOMPurify.sanitize(val);
  }
  @Input() disableRightClick: boolean;
  @Input() readOnly: boolean;
  @Output() onContentChanged: BehaviorSubject<any> = new BehaviorSubject({});

  constructor(){}
    
  ngOnInit(){}

  ngAfterViewInit(): void {
    if (this.disableRightClick){
      
      document.getElementsByClassName('ql-editor')[0].addEventListener('contextmenu', (event: MouseEvent) => {
        event.preventDefault();
        event.stopPropagation();

        // we record the mouse position in our object 
        this.menuTopLeftPosition.x = event.clientX + 'px';
        this.menuTopLeftPosition.y = event.clientY + 'px';
  
        // we open the menu 
        this.matMenuTrigger.openMenu(); 
      });
    }
  }

  onValueChange(value) {
    this.onContentChanged.next(DOMPurify.sanitize(value));
  }

  copyNote(){
    document.execCommand('copy');
  }
}
